'use strict';

(function () {
    'use strict';

    // Usage:
    // 
    // Creates:
    // 

    InfrastructureMapController.$inject = ['$q', '$scope', '$translate', 'iotService', 'measurementsService'];
    angular.module('app.iot').component('infrastructureMap', {
        require: { app: '^app' },
        template: '<style type="text/css">\n    h3 {\n        margin-bottom: 15px;\n    }\n    table>tbody>tr:first-child>th,\n    table>tbody>tr:first-child>td {\n        border-top: none;\n    }\n</style><div translate-namespace="iot"><div style="height:calc(100vh - 180px);"><leaflet lf-center="$ctrl.mapConfig.center" markers="$ctrl.mapMarkers" events="$ctrl.mapConfig.events" width="100%" height="100%"></leaflet></div><script type="text/ng-template" id="template/infrastructure-marker.html"><h3>{{$ctrl.selectedMarker[$ctrl.translations[\'foi.name\']]}}</h3> <table class="table table-condensed table-striped"> <tbody> <tr ng-repeat="modality in $ctrl.selectedMarker.modalities | orderBy: $ctrl.translations[\'modality.name\']" ng-init="measurement = $ctrl.latestMeasurements[$ctrl.selectedMarker.id][modality.slug]"> <th>{{modality[$ctrl.translations[\'modality.name\']]}}</th> <td> <span ng-if="!measurement">--</span> <span ng-if="measurement" ng-switch="modality.slug"> <span ng-switch-when="wind-direction">{{measurement | toCompass:$ctrl.compass:\'?\'}} <i class="fa fa-long-arrow-up" style="transform:rotate({{measurement | toDirection}}deg)" aria-hidden="true"></i></span> <span ng-switch-when="wind-speed">{{measurement | toBeaufort }} Bf - {{measurement | number:1}} {{modality.unit}}</span> <span ng-switch-default>{{measurement | number:1}} {{modality.unit}}</span> </span> </td> <td ng-if="modality.category.id === 1 || modality.slug === \'wind-direction\'"> <a ng-if="modality.slug == \'wind-direction\'" ui-sref="historical-data({category:1, categories: {1: { fois: [$ctrl.selectedMarker.id], modality: 14 }}})"><i class="fa fa-line-chart" aria-hidden="true"></i></a> <a ng-if="modality.slug != \'wind-direction\'" ui-sref="historical-data({category:1, categories: {1: { fois: [$ctrl.selectedMarker.id], modality: modality.id }}})"><i class="fa fa-line-chart" aria-hidden="true"></i></a> </td> <td ng-if="modality.category.id === 2"> <a ui-sref="historical-data({category:2, categories: {2: { fois: [$ctrl.selectedMarker.id], modality: modality.id }}})"><i class="fa fa-line-chart" aria-hidden="true"></i></a> </td> </tr> </tbody> </table></script></div>',
        controller: InfrastructureMapController,
        controllerAs: '$ctrl'
    });

    function InfrastructureMapController($q, $scope, $translate, iotService, measurementsService) {
        'ngInject';

        var $ctrl = this;

        ////////////////

        $ctrl.$onInit = function () {

            $ctrl.mapConfig = {
                center: {
                    lat: 35.3160385,
                    lng: 25.0762965,
                    zoom: 11
                },
                events: {
                    markers: {
                        enable: ['popupopen']
                    }
                }
            };

            $scope.$on('leafletDirectiveMarker.popupopen', function (event, args) {
                $ctrl.selectedMarker = args.model;
            });

            $ctrl.mapMarkers = {};

            $q.all({
                categories: iotService.getCategories(),
                fois: iotService.getInfrastructure(),
                translations: getTranslations()
            }).then(function (r) {
                $ctrl.categories = r.categories;
                $ctrl.translations = r.translations;

                setTranslations($ctrl.translations);

                $ctrl.categoriesIndexed = _.keyBy($ctrl.categories, 'slug');

                $ctrl.urbanFois = iotService.filterFoisByModalityIds(r.fois, $ctrl.categoriesIndexed['urban-environment'].modality_ids);
                $ctrl.waterFois = iotService.filterFoisByModalityIds(r.fois, $ctrl.categoriesIndexed['water-resources'].modality_ids);

                $ctrl.mapMarkers = _([$ctrl.urbanFois, $ctrl.waterFois]).flatMap().map(function (o) {
                    return _(o).omit(['devices']).assign({
                        message: '<div ng-include src="\'template/infrastructure-marker.html\'"></div>',
                        getMessageScope: function getMessageScope() {
                            return $scope;
                        },
                        lat: o.latitude,
                        lng: o.longitude,
                        focus: false
                    }).value();
                }).value();

                return $q.all({
                    urbanLatest: measurementsService.getLatestFoiMeasurements($ctrl.urbanFois),
                    waterLatest: measurementsService.getLatestWaterFoiMeasurements($ctrl.waterFois)
                });
            }).then(function (r) {
                $ctrl.latestMeasurements = r.urbanLatest;
                $ctrl.latestWaterMeasurements = r.waterLatest;
            });
        };

        /**
         * 
         */
        function getTranslations() {
            return $translate(['foi.name', 'modality.name', 'compass.N', 'compass.NNE', 'compass.NE', 'compass.ENE', 'compass.E', 'compass.ESE', 'compass.SE', 'compass.SSE', 'compass.S', 'compass.SSW', 'compass.SW', 'compass.WSW', 'compass.W', 'compass.WNW', 'compass.NW', 'compass.NNW']);
        }

        function setTranslations(i18n) {
            $ctrl.compass = [i18n['compass.N'], i18n['compass.NNE'], i18n['compass.NE'], i18n['compass.ENE'], i18n['compass.E'], i18n['compass.ESE'], i18n['compass.SE'], i18n['compass.SSE'], i18n['compass.S'], i18n['compass.SSW'], i18n['compass.SW'], i18n['compass.WSW'], i18n['compass.W'], i18n['compass.WNW'], i18n['compass.NW'], i18n['compass.NNW']];
        }
    }
})();